import request from '../../../shared/request'

export function getJobSiteTransmittals(job_id) {
  return request(`/job/job_site_transmittals/${job_id}/`)
}

export function getTransmittalData(transmittal_id) {
  return request(`/job/job_site_transmittals/info/${transmittal_id}/`)
}

export function createJobSiteTransmittal(payload) {
  return request(`/job/job_site_transmittals/${payload.transmittal_data.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobSiteTransmittal(payload) {
  return request(`/job/job_site_transmittals/${payload.transmittal_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobSiteTransmittal(transmittal_id) {
  return request(`/job/job_site_transmittals/${transmittal_id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadTransmittalAttachments(payload) {
  return request(`/job/job_site_transmittals/${payload.transmittalId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getTransmittalAttachments(transmittal_id) {
  return request(`/job/job_site_transmittals/${transmittal_id}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_site_transmittals/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteTransmittalAttachment(payload) {
  return request(`/job/job_site_transmittals/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteTransmittals.js